import {
  RadiusIDLabels,
  RentalPriceIDLabels,
  SurfaceMinimumIDLabels,
} from '@kamernet/modules/Search/messages';
import { ListingsSearchAllFilters } from '@kamernet/modules/Search/types';

export function getSearchAlertSetEventPayload(
  allFilters: ListingsSearchAllFilters,
  listingsCount: number,
) {
  return {
    citysearch: allFilters.cityName,
    radius: RadiusIDLabels[allFilters.radius],
    'max price': RentalPriceIDLabels[allFilters.maxRent],
    'min surface': SurfaceMinimumIDLabels[allFilters.minSize],
    filterCount: listingsCount,
  };
}
